import React from 'react';

import { ScrollToTopOnMount } from '~utils/common.utils';

const withScrollToTopOnMount = Component => props =>
  (
    <>
      <ScrollToTopOnMount />
      <Component {...props} />
    </>
  );

export default withScrollToTopOnMount;
